<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'AnggaranDasar',

    metaInfo: { title: 'Anggaran Dasar' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'articles-association',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'articlesassociation',
      },
    },
  }
</script>
